import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mc-maximize-dialog-button',
  templateUrl: './maximize-dialog-button.component.html',
  styleUrls: ['./maximize-dialog-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaximizeDialogButtonComponent implements OnInit {
  @Input() dialogRef: MatDialogRef<any>;
  @Input() maximized?: boolean = false;
  /** Passed through to the inner button's `color`. */
  @Input() color?: string | null = null;
  /** The size to resize the dialog to when maximized. Defaults to filling the screen; pass a smaller value (e.g. '95vw') for a "bigger" toggle instead of a true full-screen maximize. */
  @Input() maximizedWidth?: string = '100%';
  @Input() maximizedHeight?: string = '100%';
  @Output() resized = new EventEmitter<void>();

  fontIcon: string = 'icon-maximize';
  tooltip: string = 'Maximize';
  originalWidth: string;
  originalHeight: string;

  private isMaximized: boolean;

  constructor() { }

  ngOnInit(): void {
    this.originalWidth = this.dialogRef._containerInstance._config.width;
    this.originalHeight = this.dialogRef._containerInstance._config.height;

    this.isMaximized = !!this.maximized;

    if (this.isMaximized) {
      this.maximize();
    }
  }

  onResize() {
    this.isMaximized = !this.isMaximized;

    if (this.isMaximized) {
      this.maximize();
    } else {
      this.minimize();
    }
  }

  private maximize() {
    this.dialogRef.updateSize(this.maximizedWidth, this.maximizedHeight);
    this.fontIcon = 'icon-minimize';
    this.tooltip = 'Restore';
    this.emitResized();
  }

  private minimize() {
    this.dialogRef.updateSize(this.originalWidth, this.originalHeight);
    this.fontIcon = 'icon-maximize';
    this.tooltip = 'Maximize';
    this.emitResized();
  }

  // Deferred so any CSS size transition on the dialog has settled before listeners (e.g. a
  // virtual scroll viewport re-measuring itself) read the container's new dimensions.
  private emitResized() {
    setTimeout(() => this.resized.emit());
  }
}
